<script>
    export default {
        methods: {
            msg_error_dialog(message) {
                console.log(message);

                if (Array.isArray(message)) {
                    this.$dialog.error({
                        text: message.join('<br>'),
                        title: 'エラー',
                        actions: { 'false': '閉じる' }
                    });

                } else {
                    this.$dialog.error({
                        text: message,
                        title: 'エラー',
                        actions: { 'false': '閉じる' }
                    });

                }


            },
            msg_error_dialog_persistent(message) {
                console.log(message);

                if (Array.isArray(message)) {
                    this.$dialog.error({
                        text: message.join('<br>'),
                        title: 'エラー',
                        actions: { 'false': '閉じる' },
                        persistent: true
                    });

                } else {
                    this.$dialog.error({
                        text: message,
                        title: 'エラー',
                        actions: { 'false': '閉じる' },
                        persistent: true
                    });

                }


            },
            msg_info(message) {

                this.$dialog.message.info(message, {
                    position: 'center'
                });
            },
            async msg_confirm(message) {
                const res = await this.$dialog.confirm({
                    text: message,
                    title: '確認',
                    color: "primary",
                    actions: {
                        'false': 'キャンセル',
                        'true': 'OK'
                    }
                });

                return res;
            },
            notify_info(message) {
                this.$dialog.notify["info"](message, {
                    position: 'top-right',
                    timeout: 3000
                });
            }
        }
    }
</script>